import { IS_LOCAL } from '@/helpers';

const ValentineStore = {
  namespaced: true,
  state() {
    return {
      /** 뒤집기 기회 미션 상태 */
      flipChanceStatus: {
        attendance: 1,
        invite: 0,
        subs: 0,
        rentalIncome: 0,
        swap: 0,
        clover: 0,
      },
      /** 초콜릿 박스 상태 */
      chocolateBox: {
        stage: 1, // 몇 번째 초콜릿 박스인지

        open: [null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null], // 오픈된 초콜릿 index
      },
      /** 나의 남은 기회 */
      myChance: 0,
      /** 초콜릿 박스 중간, 완성 보상 상태 */
      chocolateBoxRewardStatus: {
        isReceiveMiddle: false,
        isReceiveFinal: false,
        cntPair: 0,
      },
      /** 나의 완성 박스 수 보상 상태 */
      myCompleteBoxRewardStatus: {
        usrCompleteBoxes: 0,
        received: [],
      },
    };
  },
  mutations: {
    setFlipChanceStatus(state, status) {
      state.flipChanceStatus = status;
    },
    setChocolateBox(state, status) {
      state.chocolateBox = status;
    },
    setChocolateBoxOpen(state, chocolateNumberOpenObj) {
      const { index, chocolateNumber } = chocolateNumberOpenObj;
      state.chocolateBox.open[index] = chocolateNumber;
    },
    setMyChance(state, chance) {
      state.myChance = chance;
    },
    setChocolateBoxRewardStatus(state, status) {
      state.chocolateBoxRewardStatus = status;
    },
    setMyCompleteBoxRewardStatus(state, status) {
      state.myCompleteBoxRewardStatus = status;
    },
  },
  actions: {
    async fetch(_, { method, url, params }) {
      const data = method === 'get' ? { params: { ...params } } : params;
      const response = await this._vm.$axios[method](`${process.env.VUE_APP_TEST_SERVER}${url}`, data);
      return response;
    },
    /**
     * 뒤집기 기회 미션 상태 조회
     * @returns {Promise<{
     *   invite: number;
     *   subs: number;
     *   rentalIncome: number;
     *   swap: number;
     *   clover: number;
     * }>}
     */
    async getFlipChanceStatus({ dispatch }) {
      if (IS_LOCAL) {
        return {
          data: {
            invite: 1, // 초대
            subs: 1, // 청약
            rentalIncome: 1, // 임대수익
            swap: 0, // 교환소
            clover: 1, // 클로버 3개로 기회 10회 구매했는지
          },
        };
      }

      const response = await dispatch('fetch', {
        method: 'get',
        url: '/valentine/mission',
      });
      return response;
    },
    /**
     * 데일리 미션 상태 조회
     */
    async fetchFlipChanceStatus({ dispatch, commit }) {
      const { data: flipChanceStatus } = await dispatch('getFlipChanceStatus');

      commit('setFlipChanceStatus', flipChanceStatus);
      return;
    },
    /**
     * 나의 초콜릿 박스 상태 조회
     * @returns {Promise<{
     *   stage: number;
     *   board: number[];
     *   open: number[];
     * }>}
     */
    async getChocolateBox({ dispatch }) {
      if (IS_LOCAL) {
        // if (test === true)
        //   return {
        //     data: {
        //       stage: 3,
        //       open: [2, 2, 1, null, null, 6, null, null, 4, 4, null, null, 6, null, null, 1],
        //     },
        //   };
        return {
          // data: {
          //   stage: 3, // 몇 번째 초콜릿 박스인지
          //   open: [null, null, 1, null, null, 6, null, null, 4, 4, null, null, 6, null, null, 1], // 오픈된 초콜릿 index
          // },
          data: {
            stage: 2, // 몇 번째 초콜릿 박스인지
            open: [null, null, 4, 3, 4, 1, 5, null, null, 5, 3, 1], // 오픈된 초콜릿 index
          },
        };
      }

      const response = await dispatch('fetch', {
        method: 'get',
        url: '/valentine/board',
      });
      return response;
    },
    /**
     * 나의 초콜릿 박스 상태 조회
     */
    async fetchChocolateBox({ dispatch, commit }) {
      const { data: chocolateBox } = await dispatch('getChocolateBox');

      commit('setChocolateBox', chocolateBox);
      return;
    },
    /**
     * 나의 남은 기회 조회
     * @returns {Promise<number>}
     */
    async getMyChance({ dispatch }) {
      if (IS_LOCAL) {
        return { data: 13 };
      }

      const response = await dispatch('fetch', {
        method: 'get',
        url: '/valentine/chance',
      });
      return response;
    },
    /**
     * 나의 초콜릿 박스 상태 조회
     */
    async fetchMyChance({ dispatch, commit }) {
      const { data: myChance } = await dispatch('getMyChance');

      commit('setMyChance', myChance);
      return;
    },
    /**
     * 초콜릿 박스 중간, 완성 보상 상태 조회
     * @returns {Promise<{
     *  isReceiveMiddle: boolean;
     *  isReceiveFinal: boolean;
     *  cntPair: number;
     * }>}
     */
    async getChocolateBoxRewardStatus({ dispatch }) {
      if (IS_LOCAL) {
        return {
          data: {
            isReceiveMiddle: false,
            isReceiveFinal: false,
            cntPair: 8,
          },
        };
      }

      const response = await dispatch('fetch', {
        method: 'get',
        url: '/valentine/reward/box',
      });
      return response;
    },
    /**
     * 나의 초콜릿 박스 상태 조회
     */
    async fetchChocolateBoxRewardStatus({ dispatch, commit }) {
      const { data: chocolateBoxRewardStatus } = await dispatch('getChocolateBoxRewardStatus');

      commit('setChocolateBoxRewardStatus', chocolateBoxRewardStatus);
      return;
    },
    /**
     * 나의 완성 박스 수 상태 조회
     * @returns {Promise<{
     *  usrCompleteBoxes: number;
     *  received: number[];
     * }>}
     */
    async getMyCompleteBoxRewardStatus({ dispatch }) {
      if (IS_LOCAL) {
        return {
          data: {
            // 유저 완성 박스 개수 0 ~ n
            usrCompleteBoxes: 7,
            // 유저가 수령한 보상
            received: [0, 1], // index 숫자
          },
        };
      }

      const response = await dispatch('fetch', {
        method: 'get',
        url: '/valentine/reward/complete-box',
      });
      return response;
    },
    /**
     * 나의 완성 박스 수 상태 조회
     */
    async fetchMyCompleteBoxRewardStatus({ dispatch, commit }) {
      const { data: myCompleteBoxRewardStatus } = await dispatch('getMyCompleteBoxRewardStatus');

      commit('setMyCompleteBoxRewardStatus', myCompleteBoxRewardStatus);
      return;
    },
    /**
     * 초콜릿 박스 중간, 완성 보상 받기
     * @returns {Promise<number>}
     * @example 1 // 0.5, 1, 2, 2.5, 5
     */
    async postChocolateBoxReward({ dispatch }, reward) {
      if (IS_LOCAL) {
        return {
          omc: 1,
          lCoupon: 0,
          addChance: 1,
        };
      }

      const response = await dispatch('fetch', {
        method: 'post',
        url: '/valentine/reward/box',
        params: {
          reward: reward,
        },
      });
      return response;
    },
    /**
     * 초콜릿 박스 중간, 완성 보상 받기 후 완료 처리
     * @returns {Promise<{
     * omc:number,
     * lCoupon:number,
     * additionalChance:number}
     * | Error & { message: { title: string, content: string } }>}
     * */
    async submitChocolateBoxReward({ dispatch }, value) {
      try {
        const { data: reward } = await dispatch('postChocolateBoxReward', value);

        return reward;
      } catch (error) {
        if (!error.response?.data?.message) return false;

        return error.response.data.message;
      } finally {
        dispatch('fetchChocolateBoxRewardStatus');
      }
    },
    /**
     * 나의 완성 박스 수 보상 받기
     * @returns {Promise<number>}
     * @example 1 // 0.5, 1, 2, 2.5, 5
     */
    async postMyCompleteBoxReward({ dispatch }, reward) {
      if (IS_LOCAL) {
        return {
          omc: 2,
          lCoupon: 3,
        };
      }

      const response = await dispatch('fetch', {
        method: 'post',
        url: '/valentine/reward/complete-box',
        params: {
          box: reward,
        },
      });
      return response;
    },
    /**
     * 나의 완성 박스 수 보상 받기 후 완료 처리
     * @returns {Promise<{
     * omc:number,
     * lCoupon:number}
     * | Error & { message: { title: string, content: string } }>}
     * */
    async submitMyCompleteBoxReward({ dispatch }, value) {
      try {
        const { data: result } = await dispatch('postMyCompleteBoxReward', value);

        return result;
      } catch (error) {
        if (!error.response?.data?.message) return false;

        return error.response.data.message;
      } finally {
        dispatch('fetchMyCompleteBoxRewardStatus');
      }
    },
    /**
     * 클로버로 뒤집기 기회 구매
     */
    async postFlipChanceClover({ dispatch }) {
      if (IS_LOCAL) {
        return null;
      }

      await dispatch('fetch', {
        method: 'post',
        url: '/valentine/use/clover',
      });

      return;
    },
    /**
     * 클로버로 뒤집기 기회 구매
     */
    async submitFlipChanceClover({ dispatch }) {
      try {
        await dispatch('postFlipChanceClover');

        return true;
      } catch (error) {
        if (!error.response?.data?.message) return false;

        return error.response.data.message;
      } finally {
        dispatch('fetchFlipChanceStatus');
      }
    },
    /**
     * 뒤집기
     */
    async postFlipBoard({ dispatch }, submitFlipBoardObj) {
      if (IS_LOCAL) {
        const middleTest = {
          chocolateNumber: 2,
        };

        const finalTest = {
          result: 'success', // 짝 맞추기 성공 시 success, 실패 시 fail
          chocolateNumber: 2,
        };

        return status === 'middle' ? middleTest : finalTest;
      }

      const { status, index } = submitFlipBoardObj;

      const response = await dispatch('fetch', {
        method: 'post',
        url: '/valentine/choose',
        params: {
          status: status,
          selectedChocolate: index,
        },
      });

      return response;
    },
    /**
     * 뒤집기 후 완료 처리
     */
    async submitFlipBoard({ dispatch }, submitFlipBoardObj) {
      try {
        const { data: result } = await dispatch('postFlipBoard', submitFlipBoardObj);

        return result;
      } catch (error) {
        if (!error.response?.data?.message) return false;

        return error.response.data.message;
      } finally {
        dispatch('fetchMyChance');
      }
    },
    /**
     * 이벤트 1 상태 조회
     */
    async fetchEvent1GameStatus({ dispatch, commit }) {
      const [{ data: chocolateBox }, { data: myChance }, { data: chocolateBoxRewardStatus }] = await Promise.all([
        dispatch('getChocolateBox'),
        dispatch('getMyChance'),
        dispatch('getChocolateBoxRewardStatus'),
      ]);

      commit('setChocolateBox', chocolateBox);
      commit('setMyChance', myChance);
      commit('setChocolateBoxRewardStatus', chocolateBoxRewardStatus);
      return;
    },
  },
};

export default ValentineStore;
